import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {Link as RouterLink} from 'react-router-dom';
import {Can} from '../../components/Can';
import {Email} from '../../graphql/emails.datatypes';
import EmailEdit from "./EmailEdit";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    emails: Email[],
    setEmail: (email: any) => void;
    openModal: () => void;
}) => {
    const {className, emails, setEmail, openModal, ...rest} = props;
    const classes = useStyles();

    const handleModalOpen = (email: any) => {
        setEmail(email);
        openModal();
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title="All emails"
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Email</TableCell>
                                        <TableCell align="right">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {emails.map(email => (
                                        <TableRow hover key={email.id}>
                                            <TableCell>{email.email}</TableCell>
                                            <TableCell align="right">
                                                <Can permission="email.edit" data={{email}}>
                                                    <Button
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleModalOpen(email)}
                                                        variant="outlined"
                                                    >
                                                        Edit
                                                    </Button>
                                                </Can>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
            </Card>
        </div>
    );
};

export default Results;
